import { FC, useEffect, useState } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import useModalContext from '@hooks/context/useModalContext';
import { useLocales } from '@hooks/helpers/useLocales';
import { IModalComponentProps } from '@context/modal_context';
import Textarea from '@components/common/textarea';
import { TGiftCard, TGiftCardListItem } from '@xeppt/xeppt-sdk/types';
import { useIsFirstRender } from '@mantine/hooks';

const AddGiftCardDescription: FC<
    IModalComponentProps<{ description: string; isEdit: boolean; giftCard: TGiftCard }>
> = ({ modalData, changeModalData }) => {
    const isFirstRender = useIsFirstRender();
    const [description, setDescription] = useState('');
    const { handleChangeDisable, changeModalState } = useModalContext();
    const { validationLocale, labelLocale, placeholderLocale } = useLocales();

    useEffect(() => {
        handleChangeDisable(!description);
        changeModalData({ ...modalData, description });
    }, [description]);

    useEffect(() => {
        changeModalState({ confirmLabel: 'save_changes' });
        if (modalData?.giftCard?.description && isFirstRender) {
            setDescription(modalData?.giftCard?.description);
        }
    }, [modalData, isFirstRender]);

    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                {modalData?.isEdit ? 'Edit' : 'Add'} description
            </Typography>
            <div className={styles.inputs_wrapper}>
                <div className={styles.input_wrapper}>
                    <Textarea
                        label="Description"
                        full
                        value={description}
                        onChange={(val) => setDescription(val)}
                        placeholder="Add a description for the recipient"
                        helperText="This description will be shown to the recipient with the gift card"
                    />
                </div>
            </div>
        </div>
    );
};

export default AddGiftCardDescription;
